// extracted by mini-css-extract-plugin
module.exports = {"slider-inputs-container":"QuestionSlider_slider-inputs-container__1Zbnn"};